import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import {
  KFLToastContainer,
  notifyKFLToastError,
  notifyKFLToastWarning,
  notifyKFLToastSuccess,
  notifyKFLToastInfo,
} from '@kamstrup/kamstrup-frontend-library';
import { FeedbackState, ReduxState, FeedbackType } from '../../interfaces';
import * as Actions from '../../actions';
import { LMessage } from '../../core/localization';
import Translate from './localization/localize';
import Logger from '../../libs/logger';  
import { LogArea } from '../../libs/logger/const';

interface StateProps {
  feedbackState: FeedbackState;
}

type Props = StateProps;

const Feedback: React.FC<Props> = (props) => {
  useEffect(() => {
    props.feedbackState.feedbacks.forEach((fb) => {
      if (!fb.displayed) {
        let message = <div>Test</div>;
        if (Array.isArray(fb.header)) {
          const messages: LMessage[] = fb.header as LMessage[];
          message = (
            <div>
              {messages.map((m) => (
                <Translate message={m} />
              ))}
            </div>
          );
        } else {
          message = (
            <div>
              <Translate message={fb.header} />
            </div>
          );
        }
        Logger.info(['Feedback-useEffect', message, fb], LogArea.Feedback);
        switch (fb.type) {
          case FeedbackType.ERROR:
            notifyKFLToastError(message);
            break;
          case FeedbackType.WARNING:
            notifyKFLToastWarning(message);
            break;
          case FeedbackType.SUCCESS:
            notifyKFLToastSuccess(message);
            break;
          default:
            notifyKFLToastInfo(message);
            break;
        }
        Actions.feedbackSeen(fb);
      }
    });
  }, [props.feedbackState.feedbacks]);

  return <KFLToastContainer position="bottom-left" />;
};

const mapStateToProps = (state: ReduxState): StateProps => ({
  feedbackState: state.feedbackState,
});

export default connect(mapStateToProps)(Feedback);
